import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
window.$store = store;
export const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;
require('@/config/axios');

import VueMce from 'vue-mce';
Vue.use(VueMce);

import '@/assets/scss/main.scss';
import '@/js/all.js';

Vue.config.productionTip = false;

Vue.prototype.$goHome = () => {
    location.href = process.env.VUE_APP_BASEURL;
}
Vue.prototype.$urlImage = (url) => {
    return process.env.VUE_APP_BASE_PATH + url;
}
Vue.prototype.$linkUrl = (url) => {
    return process.env.VUE_APP_BASE_URL + url;
}
Vue.prototype.$getEnv = (key, isNumber = false) => {
    if(isNumber){
        return process.env[key] * 1;
    }
    return process.env[key];
}

import { isMobile, isAndroid } from 'mobile-device-detect';
Vue.prototype.$detect = window.navigator.userAgent.indexOf('WebviewVNPAPP') !== -1 ? 'mobile' : (isMobile ? 'mobile' : 'web');
Vue.prototype.$isAndroid = window.navigator.userAgent.indexOf('WebviewVNPAPP') !== -1 || isAndroid ? true : false;

Vue.prototype.$textLoadingFull = 'VẬT GIÁ';
Vue.prototype.$titleMessage = 'Vật Giá thông báo';

Vue.prototype.$goHref = (link) => {
    location.href = link;
}
import { destroyCookie } from '@/config/token';
Vue.prototype.$logout = () => {
    destroyCookie();
    location.href = 'https://vatgia.com/';
}

import { formatNumber, checkDateInput, getDate, getMoney, stringToNumber, formatNumberPhome, formatDate, pictureProductThumb } from '@/config/function';
window.stringToNumber = stringToNumber;
window.formatNumberPhome = formatNumberPhome;
window.formatNumber = formatNumber;
window.checkDateInput = checkDateInput;
window.getMoney = getMoney;
window.formatDate = formatDate;
window.pictureProductThumb = pictureProductThumb;
Vue.prototype.$getDate = (date) => {
    return getDate(date);
}
Vue.prototype.$formatNumber = formatNumber;
Vue.prototype.$formatNumberPhome = formatNumberPhome;
Vue.prototype.$stringToNumber = stringToNumber;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$pictureProductThumb = pictureProductThumb;

window.stopScoll = (e) => {
    window.scrollTo(0, 0)
}
Vue.prototype.$overflowHidenBody = () => {
    window.addEventListener('scroll', stopScoll, false);
    document.querySelector('#app').style.overflow = "hidden";
}
Vue.prototype.$removeOverflowHidenBody = () => {
    window.removeEventListener('scroll', stopScoll, false)
    document.querySelector('#app').removeAttribute('style');
}

window.errorImage = (e) => {
    if(e.target){
        // e.target.classList.add('error-img');
        e.target.src = process.env.VUE_APP_BASE_PATH + '/images/no-image.png';
    }else{
        // e.classList.add('error-img');
        e.src = process.env.VUE_APP_BASE_PATH + '/images/no-image.png'
    }

}

Vue.prototype.$errorAvatar = (e) => {
    if(e.target){
        e.target.src = process.env.VUE_APP_BASE_PATH + '/images/women.svg';
    }else{
        e.src = process.env.VUE_APP_BASE_PATH + '/images/women.svg'
    }
}


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
